module.exports = __webpack_public_path__ + "img/Schiff.a3ea651e.jpg";